import { useNavigate } from 'react-router';

import { Flags, PublicKeys } from '@/api';
import { UserFromGetSession } from '@/models/user';
import { useCurrentSession, useFlags, usePublicKeys } from '@/services/auth';

export const useCompleteLogin = () => {
  const navigate = useNavigate();

  const { setCurrentSession } = useCurrentSession();
  const { setFlags } = useFlags();
  const { setPublicKeys } = usePublicKeys();

  return ({
    user,
    flags,
    publicKeys,
  }: {
    user: UserFromGetSession;
    flags: Flags;
    publicKeys: PublicKeys;
  }) => {
    setCurrentSession(user);
    setFlags(flags);
    setPublicKeys(publicKeys);

    const redirectTo = new URLSearchParams(window.location.search).get('redirect') ?? '';

    if (redirectTo === '/' || redirectTo.match(/^\/[^/]/)) {
      navigate(redirectTo, { replace: true });

      return;
    }

    navigate('/requests', { replace: true });
  };
};
